import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BellIcon from '../../assets/dashboard/bell.png'
import NotificationsDropdown from './notifications-dropdown';
const Navbar = ({ username, userRole, avatarUrl, onLogout }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="row profile_row align-items-center">
  <div className="col-md-6">
    <h2 className="title_main">Dashboard</h2>
  </div>
  <div className="col-md-6">
    <div className="icon_profile text-end d-flex justify-content-end align-items-center gap-3">
      {/* <img src={BellIcon} alt="Notifications" className="notification_icon" /> */}
                    <NotificationsDropdown />


      {/* Avatar + Dropdown */}
      <div className="position-relative" ref={dropdownRef}>
        <div
          className="d-flex align-items-center gap-2"
          onClick={toggleDropdown}
          style={{ cursor: 'pointer' }}
        >
          {avatarUrl ? (
            <img src={avatarUrl} alt="Profile" className="profile_picture rounded-circle" />
          ) : (
            <div
              className="bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center"
              style={{ width: '52px', height: '52px', fontSize: '20px' }}
            >
              {username?.charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        {/* Dropdown */}
        {isDropdownOpen && (
          <div
            className="dropdown-menu show mt-2 p-2 shadow"
            style={{
              position: 'absolute',
              right: 0,
              top: '100%',
              zIndex: 1000,
            }}
          >
            <div className="px-3 py-2 border-bottom">
              <div className="fw-bold">{username}</div>
              <div className="text-muted" style={{ fontSize: '12px' }}>
                {userRole}
              </div>
            </div>
            <Link to={`${userRole}/profile`} className="dropdown-item" style={{fontSize:'16px'}}>
              Profile
            </Link>
            <button className="dropdown-item" onClick={onLogout} style={{fontSize:'16px',fontWeight:'400'}}>
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  </div>
</div>
    // <nav className="d-flex justify-content-end align-items-center p-3 bg-light border-bottom">
    //   <div className="position-relative" ref={dropdownRef}>
    //     <div
    //       className="d-flex align-items-center gap-2"
    //       onClick={toggleDropdown}
    //       style={{ cursor: 'pointer' }}
    //     >
    //       {avatarUrl ? (
    //         <img
    //           src={avatarUrl}
    //           alt="Avatar"
    //           className="rounded-circle"
    //           width="40"
    //           height="40"
    //         />
    //       ) : (
    //         <div
    //           className="bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center"
    //           style={{ width: '40px', height: '40px', fontSize: '16px' }}
    //         >
    //           {username?.charAt(0).toUpperCase()}
    //         </div>
    //       )}
    //     </div>

    //     {isDropdownOpen && (
    //       <div className="dropdown-menu dropdown-menu-end show mt-2 p-2 shadow" style={{ position: 'absolute' }}>
    //         <div className="px-3 py-2 border-bottom">
    //           <div className="fw-bold">{username}</div>
    //           <div className="text-muted" style={{ fontSize: '12px' }}>{userRole}</div>
    //         </div>
    //         <Link to="/profile" className="dropdown-item">
    //           Profile
    //         </Link>
    //         <button className="dropdown-item" onClick={onLogout}>
    //           Logout
    //         </button>
    //       </div>
    //     )}
    //   </div>
    // </nav>
  );
};

export default Navbar;
